import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
  changeView,
  initializeTest,
  setName,
  setTesterId,
} from "./../actions/assessment";

import { Modal } from "react-bootstrap";
import warningIcon from "./../assets/img/icon-warning.svg";
import config from "./../config/config-secret.json";

import { Translate } from "react-redux-i18n";
import Button from "./ui/Buttons/Button";

export class Welcome extends Component {
  constructor(props) {
    super(props);

    this.state = {
      is_agree: false,
      agreed_to_id_verification_consent: false,
      first_name: "",
      last_name: "",
      email: "",
      job_applying: "",
      job_applying: "",
      show_error_modal: false,
      show_terns_and_condition: false,
      show_agreed_to_id_verification_consent_modal: false,
      modal_message: "",
    };
  }

  useAphabetOnly = (event) => {
    if (
      !!!(
        (event.charCode >= 65 && event.charCode <= 90) ||
        (event.charCode >= 97 && event.charCode <= 122) ||
        event.charCode === 32
      )
    ) {
      event.preventDefault();
    }
  };

  handleIsAgreeChange = (e) => {
    this.setState({ is_agree: e.target.checked });
  };

  handleIdVerificationConsentChange = (e) => {
    this.setState({ agreed_to_id_verification_consent: e.target.checked });
  };

  handleFirstNameChange = (e) => {
    this.setState({ first_name: e.target.value });
  };

  handleLastNameChange = (e) => {
    this.setState({ last_name: e.target.value });
  };

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value });
  };

  handleJobApplyingChange = (e) => {
    this.setState({ job_applying: e.target.value });
  };

  closeTermsAndConditionModal = () => {
    this.setState({ show_terns_and_condition: false });
  };

  closeAgreeToIdVerificationConsentModal = () => {
    this.setState({ show_agreed_to_id_verification_consent_modal: false });
  };

  closeErrorModal = () => {
    this.setState({ show_error_modal: false });
  };

  handleValidation = async (e) => {
    var i18n = require("react-redux-i18n").I18n;
    const {
      is_agree,
      first_name,
      last_name,
      email,
      job_applying,
      agreed_to_id_verification_consent,
    } = this.state;

    if (
      first_name.length < 1 ||
      last_name.length < 1 ||
      email.length < 1 ||
      job_applying.length < 1
    ) {
      return this.setState({
        show_error_modal: true,
        modal_message: i18n.t("required"),
      });
    }

    // const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    // eslint-disable-next-line
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    if (!regex.test(email)) {
      return this.setState({
        show_error_modal: true,
        modal_message: i18n.t("valid_email"),
      });
    }

    if (!!!is_agree) {
      return this.setState({
        show_error_modal: true,
        modal_message: i18n.t("agree_check"),
      });
    }

    if (
      this.props.has_security_features &&
      !!!agreed_to_id_verification_consent
    ) {
      return this.setState({
        show_error_modal: true,
        modal_message: i18n.t("agree_id_verification_and_consent"),
      });
    }

    document.querySelector("#initloader").style.display = "";

    await axios
      .post(config.API_URL + "/administer_test/create_tester/", {
        exam_id: this.props.exam_id,
        lang: this.props.lang,
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        email: this.state.email,
        job_position: this.state.job_applying,
        last_session_info: JSON.stringify({}),
      })
      .then((res) => {
        const response = res.data;

        if (response.success === false) {
          document.querySelector("#initloader").style.display = "none";
          let error_msg = i18n.t("tester_error");

          if (response.error_message) {
            error_msg = response.error_message;
          }

          return this.setState({
            show_error_modal: true,
            modal_message: error_msg,
          });
        }

        if ("last_session_info" in response.data) {
          const tester_id = response.data.tested_id;
          const last_session_info = JSON.parse(response.data.last_session_info);

          const exam_id = last_session_info.exam_id;
          const exams = last_session_info.exams;
          const total_questions = last_session_info.total_questions;
          const approximate_time = last_session_info.approximate_time;
          const sessions = last_session_info.sessions;

          this.props.initializeTest(
            exam_id,
            tester_id,
            sessions,
            exams,
            total_questions,
            approximate_time,
            last_session_info,
          );
        } else {
          this.props.setTesterId(response.data.tested_id);
          this.props.setName(
            this.state.first_name,
            this.state.last_name,
            this.state.email,
            this.state.job_applying,
          );

          if (this.props.has_security_features) {
            this.props.continue("id_capture_instructions");
          } else if (Object.keys(this.props.demographic_fields).length > 0) {
            this.props.continue("demographic");
          } else if (
            Object.keys(this.props.sport_demographic_fields).length > 0
          ) {
            this.props.continue("sport_demographic");
          } else {
            this.props.continue("session_details");
          }
        }

        document.querySelector("#initloader").style.display = "none";
      })
      .catch((error) => {
        console.log(error);
        alert(i18n.t("alert_error"));
      });
  };

  render() {
    const i18n = require("react-redux-i18n").I18n;
    return (
      <div>
        <div className="main container-fluid h-100">
          <div className="row h-100 justify-content-center align-items-center">
            <div className="col-12">
              <div className="container">
                <div className="row  justify-content-center ">
                  <div className="col-md-6 ">
                    <div className="test-info ">
                      <h3 className="mt-4 mb-3 text-center">
                        <Translate value="ready" />
                      </h3>
                      <p className="mb-4">
                        <Translate value="code" /> {this.props.code}{" "}
                      </p>

                      <form className="form-custom">
                        <div className="form-label-group">
                          <input
                            type="text"
                            id="txtFirstName"
                            name="first_name"
                            className="form-control"
                            placeholder={i18n.t("firstname")}
                            onKeyPress={(event) => this.useAphabetOnly(event)}
                            onChange={this.handleFirstNameChange}
                            value={this.state.first_name}
                            autoComplete="off"
                          />
                          <label htmlFor="txtFirstName">
                            <Translate value="firstname" />
                          </label>
                        </div>

                        <div className="form-label-group">
                          <input
                            type="text"
                            id="txtLastName"
                            name="last_name"
                            className="form-control"
                            placeholder={i18n.t("lastname")}
                            onKeyPress={(event) => this.useAphabetOnly(event)}
                            onChange={this.handleLastNameChange}
                            value={this.state.last_name}
                            autoComplete="off"
                          />
                          <label htmlFor="txtLastName">
                            <Translate value="lastname" />
                          </label>
                        </div>

                        <div className="form-label-group">
                          <input
                            type="email"
                            id="txtEmail"
                            name="email"
                            className="form-control"
                            placeholder={i18n.t("email")}
                            onChange={this.handleEmailChange}
                            value={this.state.email}
                            autoComplete="off"
                          />
                          <label htmlFor="txtEmail">
                            <Translate value="email" />
                          </label>
                        </div>

                        <div className="form-label-group">
                          <input
                            type="text"
                            id="txtJobApplying"
                            name="job_applying"
                            className="form-control"
                            placeholder="NA" // i18n.t("job")
                            // onKeyPress={event => this.useAphabetOnly(event)}
                            onChange={this.handleJobApplyingChange}
                            value={this.state.job_applying}
                            autoComplete="off"
                            style={{
                              paddingTop: "3.2rem",
                              paddingBottom: ".75rem",
                            }}
                          />
                          <label htmlFor="txtJobApplying">
                            <Translate value="job" />
                            <br />
                            <span style={{ fontSize: "10px" }}>
                              <Translate value="job_note" />
                            </span>
                          </label>
                          {/* If you are not taking this assessment as part of a job application, please write N/A. */}
                        </div>
                        <div className="checkbox mb-3">
                          <label>
                            <input
                              type="checkbox"
                              id="chkAgreeTermsAndCondition"
                              onChange={this.handleIsAgreeChange}
                              defaultChecked={this.state.is_agree}
                            />{" "}
                            <Translate value="agree" />{" "}
                            {/* <button
                              className="termsButton"
                              type="button"
                              onClick={() =>
                                this.setState({
                                  show_terns_and_condition: true,
                                })
                              }
                            >
                              <Translate value="terms" />
                            </button> */}
                            <Button
                              variant="primary"
                              className="termsButton"
                              onClick={() =>
                                this.setState({
                                  show_terns_and_condition: true,
                                })
                              }
                            >
                              <Translate value="terms" />
                            </Button>
                          </label>
                        </div>

                        {this.props.has_security_features && (
                          <div className="checkbox mb-3">
                            <label>
                              <input
                                type="checkbox"
                                id="chkIdVerificationAndConsent"
                                onChange={
                                  this.handleIdVerificationConsentChange
                                }
                                defaultChecked={
                                  this.state.agreed_to_id_verification_consent
                                }
                              />{" "}
                              <Translate value="agree" />{" "}
                              {/* <button
                                className="termsButton"
                                type="button"
                                onClick={() =>
                                  this.setState({
                                    show_agreed_to_id_verification_consent_modal: true,
                                  })
                                }
                              >
                                <Translate value="id_verification_and_consent" />
                              </button> */}
                              <Button
                                variant="primary"
                                className="termsButton"
                                onClick={() =>
                                  this.setState({
                                    show_agreed_to_id_verification_consent_modal: true,
                                  })
                                }
                              >
                                <Translate value="id_verification_and_consent" />
                              </Button>
                            </label>
                          </div>
                        )}
                      </form>
                      <div className="button-wrap">
                        {/* <button
                          className="btn btn-main btn-global btn-block"
                          // disabled={!!!enabled}
                          onClick={this.handleValidation}
                        >
                          <Translate value="cont" />
                        </button> */}
                        <Button
                          variant="primary"
                          className="btn-global btn-block"
                          onClick={this.handleValidation}
                        >
                          <Translate value="cont" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={this.state.show_error_modal}
          onHide={this.closeErrorModal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div
              className="text-center mt-5 mb-5"
              style={{ whiteSpace: "pre-line" }}
            >
              <img src={warningIcon} className="icon" alt={i18n.t("expired")} />
              <br />
              <br />
              {/* <h2 className="title">
                Warning
              </h2> */}
              <p>{this.state.modal_message}</p>

              <div className="button-wrap mt-md-5">
                {/* <button
                  className="btn btn-success btn-sm"
                  // data-dismiss="modal"
                  onClick={() => {
                    this.setState({
                      show_error_modal: false,
                    });
                  }}
                >
                  <Translate value="close" />
                </button> */}
                <Button
                  variant="primary"
                  onClick={() =>
                    this.setState({
                      show_error_modal: false,
                    })
                  }
                >
                  <Translate value="close" />
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.show_terns_and_condition}
          onHide={this.closeTermsAndConditionModal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div className="text-center mt-2 mb-5">
              <h4>
                <Translate value="mterms" />
              </h4>
              <hr />
              <br />
              <p className="text-justify mx-3">
                {
                  //this.props.assessment.candidate_consent
                }
                <Translate value="txt_terms" />
              </p>
              <p className="text-justify mx-3">
                {
                  //this.props.assessment.candidate_consent
                }
                <Translate value="txt_terms2" />
              </p>
              <div className="button-wrap mt-5">
                {/* <button
                  className="btn btn-success btn-sm"
                  // data-dismiss="modal"
                  onClick={() => {
                    this.setState({
                      show_terns_and_condition: false,
                    });
                  }}
                >
                  <Translate value="close" />
                </button> */}
                <Button
                  variant="primary"
                  onClick={() =>
                    this.setState({
                      show_terns_and_condition: false,
                    })
                  }
                >
                  <Translate value="close" />
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          size="lg"
          show={this.state.show_agreed_to_id_verification_consent_modal}
          onHide={this.closeAgreeToIdVerificationConsentModal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div
              className="text-center mt-2 mb-5"
              style={{ whiteSpace: "pre-line" }}
            >
              <h4>
                <Translate value="m_id_verification_and_consent" />
              </h4>
              <hr />
              <br />
              <p className="text-justify mx-3">
                <Translate value="txt_id_verification" />
              </p>
              <p className="text-justify mx-3 border border-info p-3">
                <Translate value="txt_id_consent" />
              </p>
              <div className="button-wrap mt-5">
                {/* <button
                  className="btn btn-success btn-sm"
                  // data-dismiss="modal"
                  onClick={() => {
                    this.setState({
                      show_agreed_to_id_verification_consent_modal: false,
                    });
                  }}
                >
                  <Translate value="close" />
                </button> */}
                <Button
                  variant="primary"
                  onClick={() =>
                    this.setState({
                      show_agreed_to_id_verification_consent_modal: false,
                    })
                  }
                >
                  <Translate value="close" />
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.assessment.lang,
  code: state.assessment.code,
  exam_id: state.assessment.exam_id,
  demographic_fields: state.assessment.demographic_fields,
  sport_demographic_fields: state.assessment.sport_demographic_fields,
  id_capture_fields: state.assessment.id_capture_fields,
  has_security_features: state.assessment.has_security_features,
});

const mapDispatchToProps = (dispatch) => ({
  continue: (view) => dispatch(changeView(view)),
  setTesterId: (tester_id) => dispatch(setTesterId(tester_id)),
  setName: (first_name, last_name, email_address, job_applying) =>
    dispatch(
      setName({
        first_name,
        last_name,
        email_address,
        job_applying,
      }),
    ),
  initializeTest: (
    exam_id,
    tester_id,
    sessions,
    exams,
    total_question,
    approximate_time,
    last_session_info,
  ) =>
    dispatch(
      initializeTest(
        exam_id,
        tester_id,
        sessions,
        exams,
        total_question,
        approximate_time,
        last_session_info,
      ),
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
